<template>
  <div>
    <base-modal-bottom
      ref="modal"
      title="Cadastro de titulares"
      :wedId="wed_id"
      :btnClose="false"
    >
      <template #btn-close-icon>
        <i class="icon">
          <base-icon name="painel/close-icon" />
        </i>
      </template>

      <div v-if="step == 1" class="c-register-name-and-cpf">
        <p>Por favor, informe quem são os titulares desta conta.</p>
        <form
          v-on:submit.prevent="submit"
          class="c-register-name-and-cpf__form"
        >
          <p class="has-text-left c-register-name-and-cpf__fiance-name"></p>
          <div class="c-register-name-and-cpf__controls">
            <base-input
              v-on:input="full_name = $event"
              :value="full_name"
              :hasError="
                validation.hasError('full_name') || full_name_error
                  ? true
                  : false
              "
              :firstError="
                validation.firstError('full_name') || full_name_error
              "
              :isPassed="validation.isPassed('full_name') && !full_name_error"
            >
              Seu nome completo
            </base-input>
          </div>
          <div class="c-register-name-and-cpf__controls">
            <base-input
              v-on:input="cpf = $event"
              :value="cpf"
              :hasError="validation.hasError('cpf') || cpf_error ? true : false"
              :firstError="validation.firstError('cpf') || cpf_error"
              :isPassed="validation.isPassed('cpf') && !cpf_error"
              type="tel"
              format="###.###.###-##"
            >
              Seu CPF
            </base-input>
          </div>
          <br />
          <p class="has-text-left c-register-name-and-cpf__fiance-name"></p>
          <div class="c-register-name-and-cpf__controls">
            <base-input
              v-on:input="full_name2 = $event"
              :value="full_name2"
              :hasError="
                validation.hasError('full_name2') || full_name2_error
                  ? true
                  : false
              "
              :firstError="
                validation.firstError('full_name2') || full_name2_error
              "
              :isPassed="validation.isPassed('full_name2') && !full_name2_error"
            >
              Nome completo do seu amor
            </base-input>
          </div>

          <div class="c-register-name-and-cpf__controls">
            <base-input
              v-on:input="cpf2 = $event"
              :value="cpf2"
              :hasError="
                validation.hasError('cpf2') || cpf_error2 ? true : false
              "
              :firstError="validation.firstError('cpf2') || cpf_error2"
              :isPassed="validation.isPassed('cpf2') && !cpf_error2"
              type="tel"
              format="###.###.###-##"
            >
              CPF do seu amor
            </base-input>
          </div>

          <base-button-bottom
            :disabled="!formIsValidated"
            :class="{
              'is-primary': formIsValidated,
            }"
            type="submit"
            class="is-black is-big"
            tag="button"
          >
            Continuar
          </base-button-bottom>
        </form>
      </div>
      <div v-if="step == 2" class="c-confirm-name-and-cpf">
        <p>
          Antes de prosseguir, por favor, revise com cuidado e confirme se os
          dados informados estão realmente corretos:
        </p>
        <form class="c-register-name-and-cpf__form">
          <div class="data-group">
            <div>
              <p>Seus dados:</p>
              <span> {{ full_name }} </span>
              <br />
              <span> CPF: {{ cpf }} </span>
            </div>
            <hr />
            <div>
              <p>Dados do seu amor:</p>
              <span> {{ full_name2 }} </span>
              <br />
              <span> CPF: {{ cpf2 }} </span>
            </div>
          </div>
          <b-checkbox v-model="checkData" class="check">
            Declaro que revisei meus dados e confirmo que estão corretos.
          </b-checkbox>
          <p v-if="showCheckError" class="check-error">
            Para prosseguir é necessário confirmar que os dados foram revisados.
          </p>
          <div class="actions">
            <button
              class="is-white is-big change-button base-button"
              type="button"
              @click="step = 1"
            >
              Alterar dados
            </button>
            <button
              :class="{
                'is-loading': formLoading,
                'is-disabled': !checkData,
              }"
              type="button"
              class="is-big base-button is-black next-button"
              @click="setOwnerInfo"
            >
              Continuar
            </button>
          </div>
        </form>
      </div>
    </base-modal-bottom>
    <BaseModalError
      ref="errorApi"
      title="Ops... algo deu errado!"
      icon="error-api"
      message="<strong>Não conseguimos registrar os dados informados!</strong>"
      sub-message="Por favor, entre em contato com o nosso time de atendimento para que possamos te ajudar."
      :has-button="false"
    />
  </div>
</template>

<script>
import BaseModalBottom from '@/components/BaseModalBottom.vue'
import BaseButtonBottom from '@/components/BaseButtonBottom.vue'
import BaseModalError from '@/components/BaseModalError.vue'
import BaseInput from '@/components/BaseInput.vue'

import loadingViewMixin from '@/mixins/loadingViewMixin'
import verifyDataUserMixin from '@/mixins/verifyDataUserMixin'
import SimpleVueValidator from 'simple-vue-validator'
import WalletApi from '@/lib/api/Wallet'

const Validator = SimpleVueValidator.Validator.create({
  templates: {
    required: 'Este campo não pode ficar vazio',
  },
})

export default {
  mixins: [SimpleVueValidator.mixin, loadingViewMixin, verifyDataUserMixin],

  components: {
    BaseModalError,
    BaseButtonBottom,
    BaseModalBottom,
    BaseInput,
  },

  props: {
    supplier: {
      type: String,
    },
    hasPhone: {
      type: Boolean,
    },
  },

  validators: {
    full_name(value) {
      return Validator.value(value)
        .required()
        .regex(/^[^0-9]*$/, 'Não é permitido números')
        .regex(/[a-zA-Z]+\s+[a-zA-Z]+/g, 'Escreva o nome completo')
    },

    cpf(value) {
      return Validator.value(value)
        .required()
        .minLength(14, 'Não foi possível validar seu CPF')
        .maxLength(14, 'Não foi possível validar seu CPF')
        .custom(() => {
          if (value == this.cpf2) {
            this.cpf_error = 'Não é possível cadastrar CPF repetidos'
          }
        })
    },
    full_name2(value) {
      return Validator.value(value)
        .required()
        .regex(/^[^0-9]*$/, 'Não é permitido números')
        .regex(/[a-zA-Z]+\s+[a-zA-Z]+/g, 'Escreva o nome completo')
        .custom(() => {
          if (!this.cpf2) {
            this.cpf_error2 = 'Preencha o CPF'
          }

          if (this.cpf2 && !this.full_name2) {
            this.full_name2_error = 'Preencha este campo'
          }

          if (!this.cpf2 && !this.full_name2) {
            this.cpf_error2 = null
          }
        })
    },

    cpf2(value) {
      return Validator.value(value)
        .required()
        .minLength(14, 'Não foi possível validar seu CPF')
        .maxLength(14, 'Não foi possível validar seu CPF')
        .custom(() => {
          if (!this.full_name2) {
            this.full_name2_error = 'Preencha o nome completo'
          }

          if (!this.cpf2 && this.full_name2) {
            this.cpf_error2 = 'Preencha este campo'
          }

          if (value == this.cpf) {
            this.cpf_error2 = 'Não é possível cadastrar CPF repetidos'
          }

          if (!this.cpf2 && !this.full_name2) {
            this.full_name2_error = null
          }
        })
    },
  },

  computed: {
    formIsValidated() {
      return (
        this.validation.isPassed('full_name') &&
        this.validation.isPassed('cpf') &&
        this.cpf !== this.cpf2 &&
        this.full_name !== this.full_name2 &&
        this.validation.isPassed('full_name2') &&
        this.validation.isPassed('cpf2')
      )
    },

    logonToken() {
      return this.$store.state.app.logonToken
    },

    externalToken() {
      return this.$store.state.wallet.externalToken
    },

    walletSummary() {
      return this.$store.state.wallet.walletSummary
    },

    wedSiteInfo() {
      return this.$store.state.app.wedSiteInfo
    },
  },

  data() {
    return {
      full_name: '',
      full_name2: '',
      cpf: '',
      cpf2: '',
      full_name_error: null,
      cpf_error: null,
      full_name2_error: null,
      cpf_error2: null,
      formLoading: false,
      checkData: false,
      showCheckError: false,
      view: false,
      params: null,
      wed_id: null,
      step: 1,
    }
  },

  watch: {
    cpf() {
      this.cpf_error = null
    },

    full_name() {
      this.full_name_error = null
    },

    cpf2() {
      this.cpf_error2 = null
    },

    full_name2() {
      this.full_name2_error = null
    },

    logonToken(payload) {
      if (payload.token_payload.wed_id)
        this.wed_id = payload.token_payload.wed_id
    },

    walletSummary(payload) {
      if (!payload.pending && !payload.loading && !this.view) this.start()
    },
  },

  created() {
    setTimeout(() => this.getWedId(), 500)
  },

  mounted() {
    this.start()
  },

  methods: {
    getWedId() {
      !this.wed_id && this.logonToken.token_payload.wed_id
        ? (this.wed_id = this.logonToken.token_payload.wed_id)
        : ''
    },

    start() {
      this.$refs.modal.open()
    },

    submit() {
      this.formLoading = true

      this.$validate().then((success) => {
        if (success) this.step = 2
      })
    },

    setOwnerInfo() {
      if (this.checkData) {
        this.showCheckError = false
        const walletApi = new WalletApi(this.logonToken)
        if (
          this.logonToken &&
          this.logonToken.token_payload &&
          this.logonToken.token_payload.wallet_id
        ) {
          walletApi
            .setOwnerInfo({
              full_name: this.full_name,
              cpf: this.cpf,
              full_name2: this.full_name2,
              cpf2: this.cpf2,
            })
            .then(() => {
              this.loading = true
              !this.params ? this.firstAccessWallet() : this.goTo(this.params)
            })
            .catch((error) => {
              this.step = 1

              if (error.response.status === 422) {
                const errorsInput = error.response.data.error.errors

                this.full_name_error = errorsInput.full_name
                  ? errorsInput.full_name[0]
                  : null
                this.cpf_error = errorsInput.cpf ? errorsInput.cpf[0] : null

                this.full_name2_error = errorsInput.full_name2
                  ? errorsInput.full_name2[0]
                  : null
                this.cpf_error2 = errorsInput.cpf2 ? errorsInput.cpf2[0] : null
              } else this.$refs.errorApi.open()
            })
            .finally(() => (this.formLoading = false))
        }
      } else {
        this.showCheckError = true
      }
    },

    open(params) {
      if (params) this.params = params
      this.$refs.modal.open()
    },
  },
}
</script>

<style lang="scss" scoped>
.c-register-name-and-cpf {
  max-width: 450px;
  margin: 0 auto;
  padding: 10px;
  text-align: center;

  &__form {
    padding: 1em 0;
  }

  &__controls {
    margin: 1em 0;
    &:last-of-type {
      margin-bottom: 3em;
    }
  }

  &__fiance-name {
    padding: 1px;
  }
}

.c-confirm-name-and-cpf {
  max-width: 450px;
  margin: 0 auto;
  padding: 10px;
  text-align: center;

  hr {
    height: 1px;
    background: #b4c5d6;
  }

  &__form {
    padding: 1em 0;
  }
  .actions {
    margin-top: 36px;
    @media (min-width: $tablet) {
      display: flex;
      justify-content: center;
      align-items: flex-start;
      gap: 16px;
    }

    :nth-child(2) {
      color: white !important;
    }

    .base-button {
      border-radius: 24px;
      position: static;
      display: flex;
      height: 48px;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      cursor: pointer;
      border-radius: 100px;
      font-weight: 700;
      font-family: Lato;

      padding: 16px 24px;
      gap: 16px;
      @media (max-width: $tablet) {
        display: block;
        width: 100%;
      }
      @media (min-width: $tablet) {
        width: 152px;
      }
    }
    .change-button {
      border: 1px solid #5d758d;
      color: #5d758d;
      background-color: white;

      @media (min-width: $tablet) {
        margin-right: 16px;
      }
      @media (max-width: $tablet) {
        margin-bottom: 12px;
      }
    }
    .next-button {
      color: white;
      background-color: #e583a2;
      border-color: transparent;
    }
    .is-disabled {
      background-color: #8493a2;
      box-shadow: none;
      opacity: 0.5;
      cursor: default;
    }
  }
  .check {
    font-size: 14px;
    border-color: black;
  }

  .check-error {
    color: $error;
    font-size: 12px;
  }
  .data-group {
    margin: 48px 0;
    font-size: 16px;
    text-align: left;
    p {
      color: $primary;
      margin-bottom: 16px;
      font-weight: 700;
    }
  }
  &__controls {
    margin: 1em 0;
    &:last-of-type {
      margin-bottom: 3em;
    }
  }

  &__fiance-name {
    padding: 1px;
  }
}
</style>
